<template>
  <div :style="styles.base">
    <div :class="getCss('container')" :style="imgStyle"></div>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';

export default {
  name: 'CCountdownBanner',
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'countdown-banner-',
      currentImg: '',
    };
  },
  computed: {
    imgStyle() {
      return {
        background: `url(${this.currentImg}) 0% 0% / contain no-repeat`,
      };
    },
  },
  mounted() {
    console.log('configurationData=', this.configurationData);
    this.initialize();
  },
  methods: {
    initialize() {
      const getNow = () => new Date().getTime();
      // 毫秒时间戳
      const getYearMonthDay = (time) => {
        const date = new Date(time);
        const Y = date.getFullYear();
        const M = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        const D = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
        return `${Y}/${M}/${D}`;
      };
      const getTimeStamp = stringTime => new Date(stringTime).getTime();

      const { imgList, dayCount, updateDayPoint } = this.configurationData;
      let { endTime } = this.configurationData;
      if (!imgList || imgList.length === 0) {
        return false;
      }
      if (isNaN(dayCount) || dayCount < 0) {
        return false;
      }

      if (!endTime || endTime.length === 0) {
        return false;
      }

      if (this.$platform.isIos) {
        endTime = endTime.replace(/-/g, '/');
      }
      // 当前时间戳
      const nowTimeStamp = getNow();
      // 当前时间年月日
      const nowTimeDate = getYearMonthDay(nowTimeStamp);
      // 判定节点时间戳
      const judgeTimeStamp = getTimeStamp(`${nowTimeDate} ${updateDayPoint}`);

      const count = imgList.length;
      let day = 1;

      let left = getTimeStamp(endTime) - judgeTimeStamp;
      if (left > 0) {
        left = parseInt(left / 1000, 10);
        day = left > 0 ? Math.ceil(left / (dayCount * 86400)) : 1;
        day = day > count ? count : day;
      }

      const url = imgList[day - 1].img ? imgList[day - 1].img : '';

      this.currentImg = url;
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
